import React, { useEffect, useState } from "react";
import * as actionCreators from "./../../actions";
import { Modal, Button, Alert } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SpinnerLoading from "../SpinnerLoading";
import "./styles.css";
import { validatePlan } from "../../actions/webServices";

function Table({
  firstStep,
  products,
  selectPlan,
  loading,
  motoQuotes,
  setLoading,
  saveMenu,
  vendor,
  codusu,
  company,
  codpmpol,
}) {
  const [show, setShow] = useState(false);
  const [planSelected, setPlanSelected] = useState({});
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [error, setError] = useState(false);
  const viewPlanDetails = (plan, ix) => {
    let planFiltered = products.filter(
      (item) => item.plan === plan && item.section === firstStep.codsec
    )[0];
    if (Number(planFiltered.price) === 0) {
      let matchingQuote = motoQuotes.find(
        (quote) => quote.codpro === planFiltered.codpro
      );
      if (!matchingQuote) {
        matchingQuote = motoQuotes.find(
          (quote) => quote.plan === planFiltered.codpro
        );
      }
      planFiltered = {
        ...planFiltered,
        description: matchingQuote?.description,
        price: matchingQuote?.valor,
        sumAssured: matchingQuote?.suma,
      };
    }
    setPlanSelected(planFiltered);
    handleShow();
  };

  const handleSubmit = async (plan) => {
    selectPlan(plan.plan, plan.codpro, plan.price, plan.sumAssured);
    if (firstStep?.codcia == 115) {
      const valid = await validatePlan(codpmpol, plan);
      if (!valid) {
        setError(true);
        setShow(false);
        return;
      } else {
        setError(false);
        //setShow(false);
        navigate("/qs/titularData");
      }
    } else {
      navigate("/qs/titularData");
    }
  };

  const cotizar = () => {
    setLoading();
    saveMenu(
      {
        ...firstStep,
        vendor,
        codusu,
        sumAssured: firstStep.sumAssured?.replaceAll(".", "").replace("$ ", ""),
      },
      company,
      codpmpol
    );
  };

  return (
    <>
      <div className="custom-border p-0 mb-3 ">
        <div className="d-flex inner-div my-0 mx-auto">
          {products
            .filter((product) => product.section === firstStep.codsec)
            .map(({ plan, price, codpro }, ix) =>
              loading ? (
                <div key={plan}>
                  <SpinnerLoading />
                </div>
              ) : (
                <div className="d-flex flex-column mx-2 width-price scroll-off">
                  <div className="d-flex flex-column custom-border color-price m-0 scroll-off">
                    <img
                      className="my-2 img-codsec"
                      src={`${process.env.REACT_APP_BASE_URL}/assets/cia/${firstStep?.codcia}.png`}
                      alt="Logo de la compañía"
                    />
                    <div className="custom-border-bottom mx-2"></div>
                    <div
                      key={plan}
                      className="mx-3 mt-2 fs-5 fw-bold color-plan"
                    >
                      {`${plan.replace("<br>", "\n")}`}.
                    </div>
                    <div key={plan} className="mx-3 mt-1 mb-3">
                      {Number(price) === 0
                        ? // motoQuotes[ix]?.valor ?
                          //     motoQuotes[ix]?.valor === "N/C" ? "N/C" : `$ ${Number(motoQuotes[ix]?.valor).toFixed(2)}`
                          motoQuotes.find(
                            (moto) =>
                              moto.codpro === codpro || moto.plan === codpro
                          )?.valor
                          ? motoQuotes.find((moto) => moto.codpro === codpro)
                              ?.valor === "N/C"
                            ? "N/C"
                            : `$ ${Number(
                                motoQuotes.find(
                                  (moto) =>
                                    moto.codpro === codpro ||
                                    moto.plan === codpro
                                )?.valor
                              ).toFixed(2)}`
                          : "No disponible"
                        : `$ ${Number(price).toFixed(2)}`}
                    </div>
                  </div>
                  <Button
                    className="text-center mt-2 mt-3 scroll-off"
                    onClick={() => viewPlanDetails(plan, ix)}
                  >
                    Seleccionar
                  </Button>
                </div>
              )
            )}
        </div>
      </div>
      <div className="errores">
        {(motoQuotes.map((e) => e.valor.includes("N/C"))?.includes(true) ||
          motoQuotes.map((e) => e.valor === "0")?.includes(true)) && (
          <Alert className="mt-2" variant="info">
            <p>
              Hubo un error al cotizar, inténtelo de nuevo{" "}
              <b onClick={cotizar} className="pointer">
                haciendo click aquí
              </b>
              . Si el problema persiste, infórmelo a soporte@platform.com.ar
            </p>
          </Alert>
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{planSelected.plan}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="itemDescription">
            {planSelected?.details && planSelected?.details[0] !== ""
              ? planSelected?.details?.map((detail) => (
                  <p dangerouslySetInnerHTML={{ __html: detail }}></p>
                ))
              : motoQuotes
                  .find((quote) => quote.plan === planSelected.value)
                  ?.description.map((e) => <p>{e}</p>)}
          </div>
          {firstStep.type === "moto" &&
          planSelected.plan?.toLowerCase().includes("cuponera") ? (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="button-tooltip-2">
                  El cliente abona solo una vez por cuatrimestre.
                </Tooltip>
              }
            >
              <p className="itemDescription">
                Cobertura cuatrimestral. Un pago de{" "}
                <b>${Number(planSelected.price).toFixed(2)}</b> por el total de
                la póliza.
              </p>
            </OverlayTrigger>
          ) : (
            <p className="itemDescription">
              <b>
                {planSelected.price
                  ? `$ ${Number(planSelected.price).toFixed(2) + " por mes"}`
                  : "Precio aún no disponible."}{" "}
              </b>
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isNaN(planSelected.price) && (
            <Button
              variant="primary"
              onClick={() => handleSubmit(planSelected)}
            >
              Contratar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      {error && (
        <Alert variant="danger">
          <p>
            La persona ya tiene una póliza contratada con el mismo plan y compañía, por favor, seleccione otro plan.
          </p>
        </Alert>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    products: state.mainReducer.products,
    firstStep: state.mainReducer.firstStep,
    loading: state.mainReducer.loading,
    motoQuotes: state.mainReducer.motoQuotes,
    company: state.mainReducer.company,
    codpmpol: state.mainReducer.codpmpol,
    vendor: state.mainReducer.user.vendor,
    codusu: state.mainReducer.user.id,
  };
}

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
